import { fetchWrapperPortal } from "./fetch";

// Create a new notification campaign
export const createCampaign = async (campaignData) => {
  return await fetchWrapperPortal({
    url: 'notifications/campaigns',
    method: 'POST',
    body: JSON.stringify(campaignData),
    addBearer: true
  });
};

// Get all notification campaigns (admin view)
export const getAllCampaigns = async () => {
  return await fetchWrapperPortal({
    url: `notifications/campaigns`,
    method: 'GET',
    addBearer: true
  });
};

// Update an existing notification campaign
export const updateCampaign = async (campaignId, campaignData) => {
  return await fetchWrapperPortal({
    url: `notifications/campaigns/${campaignId}`,
    method: 'PUT',
    body: JSON.stringify(campaignData),
    addBearer: true
  });
};

// Get all users for recipient selection
export const getUsersForNotification = async () => {
  return await fetchWrapperPortal({
    url: `users?fields=_id,display_name,email`,
    method: 'GET',
    addBearer: true
  });
};

// Send notification to users
export const sendNotification = async (notificationData) => {
  return await fetchWrapperPortal({
    url: `notifications/send`,
    method: `POST`,
    body: JSON.stringify(notificationData),
    addBearer: true
  });
};

// Get all notifications (admin view)
export const getAllNotifications = async () => {
  return await fetchWrapperPortal({
    url: `notifications/admin/all`,
    method: `GET`,
    addBearer: true
  });
};

// Get user notifications (for notification panel)
export const getUserNotifications = async (userId) => {
  return await fetchWrapperPortal({
    url: `notifications/user/${userId}`,
    method: `GET`,
    addBearer: true
  });
};

// Mark notification as read
export const markAsRead = async (notificationId, userId) => {
  return await fetchWrapperPortal({
    url: `notifications/${notificationId}/read`,
    method: `POST`,
    body: JSON.stringify({ userId }),
    addBearer: true
  });
};

// Mark notification as inactive (admin)
export const markAsInactive = async (notificationId) => {
  return await fetchWrapperPortal({
    url: `notifications/${notificationId}/inactive`,
    method: `PUT`,
    addBearer: true
  });
};

// Get notification stats (read/unread counts and user details)
export const getNotificationStats = async (notificationId) => {
  return await fetchWrapperPortal({
    url: `notifications/${notificationId}/stats`,
    method: `GET`,
    addBearer: true
  });
};

// Schedule notification for later
export const scheduleNotification = async (notificationData) => {
  return await fetchWrapperPortal({
    url: `notifications/schedule`,
    method: `POST`,
    body: JSON.stringify(notificationData),
    addBearer: true
  });
};

// Legacy/existing functions that were already being used in the codebase
export const getFilters = async () => {
  return await fetchWrapperPortal({
    url: `notifications/filters`,
    method: `GET`,
    addBearer: true
  });
};

export const sendStreamNotification = async (streamData) => {
  return await fetchWrapperPortal({
    url: `notifications/stream`,
    method: `POST`,
    body: JSON.stringify(streamData),
    addBearer: true
  });
};

export const sendEventNotification = async (eventData) => {
  return await fetchWrapperPortal({
    url: `notifications/event`,
    method: `POST`,
    body: JSON.stringify(eventData),
    addBearer: true
  });
};
